<template>
  <svg
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="chevron-right-title"
  >
    <path
      d="M0.93934 0.43934C0.353553 1.02513 0.353553 1.97487 0.93934 2.56066L7.37868 9L0.93934 15.4393C0.353553 16.0251 0.353553 16.9749 0.93934 17.5607C1.52513 18.1464 2.47487 18.1464 3.06066 17.5607L10.5607 10.0607C11.1464 9.47487 11.1464 8.52513 10.5607 7.93934L3.06066 0.43934C2.47487 -0.146447 1.52513 -0.146447 0.93934 0.43934Z"
      fill="#4B4C52"
    />
    <title id="chevron-right-title">{{ title }}</title>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ChevronRight',
  props: {
    title: {
      type: String,
      default: 'next slide',
    },
  },
};
</script>
